export class AppConfig {
    // public static server: string = 'http://localhost:8080/';
    public static server: string = 'http://smsserver.connectnpay.10.13.133.41.nip.io/';
    //public apiUrl: string = 'banksmart-admin-server/api/v1/';
    public static apiUrl: string = '';
    public static serverWithApiUrl = AppConfig.server + AppConfig.apiUrl;
    //public static websocketUrl:string = 'ws://159.89.196.45:8484/notification';
    public static websocketUrl: string = 'ws://smsserver.connectnpay.10.13.133.41.nip.io/notification';
    //public static websocketUrl: string = 'ws://localhost:9081/notification';
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sms-server-fe-release-v2.1.8.3/src/app/app.config.ts